import {filter, map} from 'lodash';
import {Fragment, useMemo} from 'react';

import {AgentParticipant, SessionHistory} from 'interfaces';
import {ParticipantRole} from 'types';

import {SessionHistoryNoteItem} from './SessionHistoryNoteItem';

type Props = {
    session: SessionHistory;
    localUserEid: number;
}

export const SessionHistoryNotesList: React.FC<Props> = ({session, localUserEid}) => {
    const participants = useMemo(() =>
        filter(session?.participants, {role: ParticipantRole.Agent}) as AgentParticipant[], [session]);

    return (
        <Fragment>
            {map(session?.notes, (note) => (
                <SessionHistoryNoteItem key={note.id} note={note} localUserEid={localUserEid} participants={participants} />
            ))}
        </Fragment>
    );

};